import React from 'react';
import './ChartHints.scss';

export default function ChartHints(): JSX.Element {
  return (
    <p className="ChartHints pdf-exclude">
      Select a time period to zoom in and click &quot;reset&quot; to zoom out <br />
      Clicking on a product in the legend will make the line disappear on the chart
    </p>
  );
}
